import React, { useContext, useState } from "react";
import { NameContext } from "../context/NameContext";
import MonoButton from "./MonoButton";

const NameForm = () => {
  const { setName, setIsNameEntered, closeNameForm, showFormDirectly } =
    useContext(NameContext);
  const [inputValue, setInputValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setName(inputValue); // Speichere den eingegebenen Namen
    setIsNameEntered(true); // Markiere die Namenseingabe als abgeschlossen
    closeNameForm(); // Schließe das Formular
  };

  if (!showFormDirectly) return null; // Zeige das Formular nur, wenn es aktiviert ist

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <form
        onSubmit={handleSubmit}
        className="bg-gradient-to-br from-gray-100 via-white to-gray-100/50  p-6 rounded shadow-lg w-[90%] max-w-[300px]"
      >
        <h2 className="text-center text-xs font-mono mb-4">Bitte gebe Deinen Namen ein:</h2>
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="welcher soll es sein?"
          className="w-full border border-gray-300 rounded p-2 mb-4 font-mono text-xs text-center focus:outline-none focus:ring-1 focus:ring-gray-800"
          autoComplete="off"
          required
        />
     <div className="flex w-full space-x-4 text-xs">
  <MonoButton className="w-full" type="button" onClick={closeNameForm}>
    Abbrechen
  </MonoButton>
  <MonoButton className="w-full" type="submit">
    Speichern
  </MonoButton>
</div>
      </form>
    </div>
  );
};

export default NameForm;